var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.667,
    height: 20,
    viewBox: "0 0 22.667 20",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "consent_icon",
    d: "M8.267,12.389H11.6a.833.833,0,1,0,0-1.667H8.267a.833.833,0,1,0,0,1.667Zm0,4.444H11.6a.833.833,0,1,0,0-1.667H8.267a.833.833,0,1,0,0,1.667Zm0,4.444H11.6a.833.833,0,1,0,0-1.667H8.267a.833.833,0,1,0,0,1.667Zm9.5-2.556a.523.523,0,0,0,.208-.042.577.577,0,0,0,.181-.125l4.111-4.139a.883.883,0,0,0,.292-.583.77.77,0,0,0-.264-.583.838.838,0,0,0-1.194,0l-3.333,3.333-1-.972A.825.825,0,1,0,15.6,16.778l1.778,1.778a.577.577,0,0,0,.181.125.523.523,0,0,0,.208.042ZM5.267,26A1.6,1.6,0,0,1,4.1,25.5a1.6,1.6,0,0,1-.5-1.167V7.667A1.6,1.6,0,0,1,4.1,6.5,1.6,1.6,0,0,1,5.267,6H24.6a1.709,1.709,0,0,1,1.667,1.667V24.333A1.709,1.709,0,0,1,24.6,26Zm0-1.667H24.6V7.667H5.267Zm0,0v0Z",
    transform: "translate(-3.6 -6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentIcon);
export default __webpack_public_path__ + "static/media/consent_icon.99b07339d57010317ca03a2cf7dd7a05.svg";
export { ForwardRef as ReactComponent };